let TEN_SHEET = {};

TEN_SHEET.sidebarMenuTemplate = "template/menu.htm";

TEN_SHEET.requireJSConfig = {
    baseUrl: "/templates/app/client/js",
    // !!! don't forget to edit build-config.js
    paths: {
        "menu-builder": "/templates/app/common/js/menu-builder",
        "dialogs-manager": "/templates/app/common/js/dialogs-manager",
        "mixin": "/templates/app/common/js/mixin",

        "app-common": "/templates/app/common/js",
        "model": "/templates/app/common/js/model",
        "collection": "/templates/app/common/js/collection",

        "jquery_ui": "/templates/common/js/lib/jquery-ui",
        "underscore": "/templates/common/js/lib/underscore",
        "backbone": "/templates/common/js/lib/backbone",

        "coffee-script": "/templates/common/js/lib/coffee-script",
        "bootstrap": "/templates/common/js/lib/bootstrap",

        "common": "/templates/common/js",
        "domReady": "/templates/common/js/lib/requirejs/domReady",
        "text": "/templates/common/js/lib/requirejs/text",
        "cs": "/templates/common/js/lib/requirejs/cs"
    },
    // !!! don't forget to edit build-config.js
    deps: [
        "jquery",
        "jquery_ui",
        "bootstrap/bootstrap-transition",
        "bootstrap/bootstrap-modal",
        "bootstrap/bootstrap-tooltip",
        "bootstrap/bootstrap-popover",
        "bootstrap/bootstrap-button",
        "bootstrap/bootstrap-tab",
        "common/lib/underscore.string"
    ],
    shim: {
        "jquery_ui": ["jquery"],
        "bootstrap/bootstrap-transition": ["jquery"],
        "bootstrap/bootstrap-modal": ["jquery"],
        "bootstrap/bootstrap-popover": ["jquery", "bootstrap/bootstrap-tooltip"],
        "common/lib/jquery.smoothZoom": ["common/lib/jquery.mousewheel"],
        "underscore.string": ["underscore"],
        "app-common/lib/picker.date": ["app-common/lib/picker"],
        "app-common/lib/picker.time": ["app-common/lib/picker"]
    },
    waitSeconds: 60
};

// "iconClass" for Symbolset font
TEN_SHEET.widgets = [
    {name: "Dashboard", iconClass: "ss-uploadcloud ss-gizmo", className: "dashboard", items: [
        {
            id: "new-dashboard",
            title: "Messages",
            iconClass: "ss-chat ss-gizmo",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT","UNPAID_CLIENT"]
        }
    ]},
    {name: "Connections", iconClass: "ss-uploadcloud ss-gizmo", className: "connections", items: [
        {
            id: "accounts",
            title: "Accounts",
            iconClass: "ss-gizmo ss-user",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT"],
        }
    ]},
    {name: "Documents", iconClass: "ss-uploadcloud ss-gizmo", className: "documents", items: [
        {
            id: "upload",
            title: "Upload",
            iconClass: "ss-gizmo ss-upload",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT", "UNPAID_CLIENT"]
        },
        {
            id: "folders",
            title: "Folders",
            iconClass: "ss-openfolder ss-gizmo",
            userRoles: ["CLIENT", "UNPAID_CLIENT", "TAX_ACCOUNTANT"],
            excludedRoles: ["USER", "SALES"]
        },
        {
            id: "new-folders",
            title: "Folders",
            iconClass: "ss-openfolder ss-gizmo",
            userRoles: ["USER", "SALES"],
            eventsCounterType: [{name: "feed.statement.created", title: "New statements", noURLid: true}]
        }
    ]},
    {name: "Reports", iconClass: "ss-files ss-gizmo", className: "reports", items: [
        {
            id: "income-statement",
            title: "Income Statement",
            iconClass: "ss-file ss-gizmo",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT", "UNPAID_CLIENT"]
        },
        {
            id: "balance-sheet",
            title: "Balance Sheet",
            iconClass: "ss-file ss-gizmo",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT", "UNPAID_CLIENT"]
        },
        {
            id: "transactions",
            title: "Transactions",
            iconClass: "ss-file ss-gizmo",
            userRoles: ["USER", "SALES"]
        },
        {
            id: "unmatched-receipts",
            title: "Unmatched Receipts",
            iconClass: "ss-files ss-gizmo",
            userRoles: ["USER", "SALES", "CLIENT", "TAX_ACCOUNTANT", "UNPAID_CLIENT"]
        },
        {
            id: "excel-documents",
            title: "Excel Documents",
            iconClass: "ss-download ss-gizmo",
            userRoles: ["USER", "SALES"]
        },
        {
            id: "download",
            title: "Download",
            iconClass: "ss-download ss-gizmo",
            userRoles: ["USER", "SALES", "TAX_ACCOUNTANT"]
        }
    ]},
    {name: "Tools", iconClass: "ss-mouse ss-gizmo", className: "tools", items: [
        {
            id: "details",
            title: "Client Details",
            iconClass: "ss-user ss-gizmo",
            userRoles: ["USER", "SALES"]
        },
        {
            id: "balance-checker",
            title: "Balance Checker",
            iconClass: "ss-gizmo ss-checkfile",
            userRoles: ["USER", "SALES"]
        },
        {
            id: "document-entry",
            title: "Document Entry",
            iconClass: "ss-notebook ss-gizmo",
            userRoles: ["USER", "SALES"],
            eventsCounterType: [{name: "feed.transaction.recategorized", title: "Client-recategorized transactions", offset: "double-offset"}, {name: "feed.receipt.recategorized", title: "Client-recategorized receipts", offset: "offset"}, {name: "feed.receipt.created", title: "New documents"}]
        },
        {
            id: "reconciliation",
            title: "Reconciliation",
            iconClass: "ss-calculator ss-gizmo",
            userRoles: ["USER", "SALES"],
            eventsCounterType: [{name: "unprocessed.statement", title: "New statements"}]
        },
        {
            id: "categorizer-rules",
            title: "Categorizer Rules",
            iconClass: "ss-compose ss-gizmo",
            userRoles: ["USER", "SALES"]
        },
        {
            id: "new-ledgers",
            title: "Ledger Accounts",
            iconClass: "ss-rows ss-gizmo",
            userRoles: ["USER", "SALES"],
        },
        {
            id: "import-excel",
            title: "Import From Excel",
            iconClass: "ss-file ss-gizmo",
            userRoles: ["USER", "SALES"]
        }
    ]}
];

TEN_SHEET.dialogs = [
    {id: "settings", tabs: [
        {
            id: "email-password",
            title: "Email &<br>Password",
            iconClass: "ss-lock ss-gizmo"
        },
        {
            id: "clientsettings",
            title: "Email<br>Preferences",
            iconClass: "ss-mail ss-gizmo"
        }
    ]},
    {id: "ledger", hideHeader: true, tabs: [
        {
            id: "create-ledger",
            title: "Create Ledger",
            iconClass: "ss-plus ss-gizmo"
        }
    ]}
];

// From common/js
// Previously this was included in the html header of the jsp along with the app-common config

TEN_SHEET.apiPrefix = "/api/v1/";

TEN_SHEET.sidebarMenuTemplate = "app-common/template/menu.htm";

TEN_SHEET.isDevEnvironment = ["localhost", "bktools.in.nginx.service.bench", "nginx.service.bench", "app.nginx.service.bench", "10sheet.ca"].indexOf(window.location.hostname) >= 0;

TEN_SHEET.clientInterfaceUrlTemplate = "//app." + window.location.hostname + "/<%=clientId%>/";

export default TEN_SHEET;
